import { z } from 'zod';

import { OrgNicheSchema } from './org-schemas.js';

// Shared between backend (DTO + use case) and admin (form + API client).
// Niche template activation — Org Admin scoped (JQ4-15 / US-CONFIG-001).

// --- Request ---

export const ActivateNicheTemplateRequestSchema = z.object({
  niche: OrgNicheSchema,
});

export type ActivateNicheTemplateRequest = z.infer<typeof ActivateNicheTemplateRequestSchema>;

// --- Response ---

export const NicheConfigResponseSchema = z.object({
  id: z.string().uuid(),
  locationId: z.string().uuid(),
  organizationId: z.string().uuid(),
  niche: OrgNicheSchema,
  templateActivatedAt: z.string(),
  templateVersion: z.number().int(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type NicheConfigResponse = z.infer<typeof NicheConfigResponseSchema>;
